<ras-page>
	<main>
		<h1>Free move-in transport</h1>

		<p class="lead">Free truck and driver or trailer hire makes moving and storing your belongings more cost effective; convenient, and hassle free.</p>

		<nav>
			<ul>
				<li><a routerLink="./" fragment="free-truck-or-trailer-hire">Free truck or trailer hire</a></li>
				<li><a routerLink="./" fragment="free-truck">Free truck</a></li>
				<li><a routerLink="./" fragment="free-trailer">Free trailer</a></li>
				<li><a routerLink="./" fragment="conditions">Conditions</a></li>
				<li><a routerLink="./" fragment="booking">Booking</a></li>
			</ul>
		</nav>

		<h2 id="free-truck-or-trailer-hire">Free truck or trailer hire</h2>
		<p>Free move in transport is the free use of either a Rent-A-Store truck or trailer for your initial move in to a Rent-A-Store storage unit. You are eligible for the use of a truck or trailer based on your location from a Rent-A-Store branch, the unit type which you lease, and availability of transport on the day you wish to move in. It's a popular service - booking is essential, and terms and conditions apply.</p>

		<h2 id="free-truck">Free truck</h2>
		<ul>
			<li>It’s completely free of charge to new customers for their move in.</li>
			<li>The fuelled truck and driver will meet you at your specified location, within 30km by road from the Rent-A-Store premises. If you are uncertain then you can check the distance on Google Maps.</li>
			<li>You simply load your goods into the truck, follow the truck to the Rent-A-Store facility and offload your goods into your storage unit.</li>
		</ul>

		<h3>Schedule</h3>
		<p>We run two 3 hour services each day, one in the morning, starting at 8:30am and one in the afternoon starting at 1pm, Monday to Saturday, excluding public holidays. Booking is essential as this service is subject to availability.</p>

		<h3>Logistics</h3>
		<p>Get the most value from this service by being prepared.</p>
		<ul>
			<li>Prepare your goods ready for loading prior to the truck’s arrival. This may include moving goods downstairs from above ground level, such as a first floor apartment.</li>
			<li>Arrange sufficient help to load your goods.</li>
			<li>Gather all your goods for storage in one place, as the truck can only be dispatched to one location.</li>
			<li>Where necessary, consult your complex or facilities manager to ensure that the truck can physically access the premises and drive up to your townhouse or office unit. Where this is not possible, the free use of a Rent-A-Store trailer is offered as a useful alternative.</li>
		</ul>
		<p>Our larger trucks can accommodate about 42 cubic meters, which is approximately the capacity of a 6x3m unit. Our smaller trucks have sufficient capacity to accomodate a 3x3 unit and smaller.</p>

		<h2 id="free-trailer">Free trailer</h2>
		<p>We have trailers available for all new tenants to use for their move in, from 6am to 6pm, free of charge. You will need a tow bar on your vehicle to tow the trailer. This is not offered in conjunction with the free truck service.</p>

		<h2 id="conditions">Conditions</h2>
		<p>You are eligible for free move in transport, a truck and driver OR trailer, based on your location from a Rent-A-Store branch, the unit type which you lease, and availability of transport on the day you wish to move in. You will be required to sign either a truck and driver agreement or a trailer hire agreement, which contains all the terms and conditions of use.</p>

		<h2 id="booking">Booking</h2>
		<p>Bookings are essential especially at our peak rental periods at the beginning and end of each month. You can book your free move in transport when you book your unit, telephonically or online.</p>
		<p>Advance booking helps make it possible for you to secure free move in transport for the time that suits you best.</p>
	</main>
</ras-page>
